import React, { useState } from "react";
import api from "../services/api";

export default function DeviceRegister({ onRegistered }) {
  const [deviceId, setDeviceId] = useState("");
  const [limit, setLimit] = useState(10);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!deviceId) return setMsg("deviceId required");
    try {
      await api.post("/devices/register", { deviceId: deviceId.trim(), limit: Number(limit) });
      setMsg("Device registered/updated");
      setDeviceId("");
      onRegistered && onRegistered();
    } catch (err) {
      console.error(err);
      setMsg("Error registering");
    }
  };

  return (
    <form onSubmit={submit} style={{ background: "#fff", padding: 20, borderRadius: 8, boxShadow: "0 5px 15px rgba(0,0,0,0.05)" }}>
      <h3>Register Device</h3>
      <div style={{ marginBottom: 10 }}>
        <input value={deviceId} onChange={(e) => setDeviceId(e.target.value)} placeholder="Device ID" style={{ width: "100%", padding: 8 }} />
      </div>
      <div style={{ marginBottom: 10 }}>
        <input type="number" value={limit} onChange={(e) => setLimit(e.target.value)} placeholder="Limit" style={{ width: "100%", padding: 8 }} />
      </div>
      <button style={{ padding: "8px 16px" , background: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px" }} type="submit">Register/Update</button>
      {msg && <div style={{ marginTop: 10 }}>{msg}</div>}
    </form>
  );
}
